module.exports = __webpack_public_path__ + "static/tab-nav-bg-78bfbf6e2c60e2cfe888b9c2f80b4659.svg";